var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message"},[_c('div',{staticClass:"message__title"},[_vm._v(" "+_vm._s(_vm.user)+" ")]),_c('div',{staticClass:"message__text"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }